// @dynamic
export abstract class Logger {

  private static enabled = false;

  private static noop = () => { };

  static init(enabled) {
    Logger.enabled = enabled;
  }

  public static get debug() {
    if (Logger.enabled) {
      return console.debug.bind(console);
    }
    return Logger.noop;
  }

  public static get error() {
    if (Logger.enabled) {
      return console.error.bind(console);
    }
    return Logger.noop;
  }

  public static get log() {
    if (Logger.enabled) {
      return console.log.bind(console);
    }
    return Logger.noop;
  }

  public static get info() {
    if (Logger.enabled) {
      return console.info.bind(console);
    }
    return Logger.noop;
  }

  public static get warn() {
    if (Logger.enabled) {
      return console.warn.bind(console);
    }
    return Logger.noop;
  }
}
